export default __webpack_public_path__ + "static/wf-ce65627844be52bd4c26435abd4fa6d6.svg";